































































































































































































import {Vue, Component} from 'vue-property-decorator';
import {State, namespace} from 'vuex-class';

import CompSelectBox from '@/components/common/CompSelectBox.vue';
import CheckBoxElement from '@/components/common/CheckBoxElement.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import ClickOutside from 'vue-click-outside';

import StockHistoryLayer from '@/components/product/stock/StockHistoryLayer.vue';
import GuideLayer from '@/components/product/stock/GuideLayer.vue';
import StockFailLayer from '@/components/product/stock/StockFailLayer.vue';
import BrandSearcher from '@/components/product/BrandSearcher.vue';

import {
  Mall,
  OptionsStocksParams,
  GetOptionsStocksExcelRequest,
  GetOptionsStocksRequest,
  PostStocksRequest,
  PostStocksAdjustRequest,
  PostStocksEditRequest,
} from 'supporter';

import { getToday, changeDateFormat, addDay } from '@/utils/dateUtils';
import {formatCurrency, getOptionNameAndValue} from '@/utils/formatUtils';
import {i18nInObjectList} from '@/utils/i18n';
import {warpHeaderTit} from '@/utils/grid/rendererUtils';
import {ncpPopup} from '@/utils/ncp';
import { GridEventProps } from 'tui-grid/types/event';
import { Row } from 'tui-grid';
import { pattern } from '@/const/regex';

const mallModule = namespace('mall');
const extraManagementCodeRegex = new RegExp(pattern['extra-management-cd'], 'g');

@Component({
  components: {
    CompSelectBox,
    CheckBoxElement,
    PeriodDateCalendar,
    ItemTable,
    StockHistoryLayer,
    GuideLayer,
    StockFailLayer,
    BrandSearcher
  },
  directives: {
    ClickOutside
  }
})
export default class Management extends Vue {
  public ifExchange: boolean = false;
  public ifStock: boolean = false;
  private editStockCntHelpData: any = {
    id: 'editStockCntHelp',
    width: 500,
    title: 'STOCK_MANAGEMENT_EDIT_STOCK_CNT_CONFIG_TOOLTIP_TIT',
    nonFooter: true
  };
  private adjustStockCntHelpData: any = {
    id: 'adjustStockCntHelp',
    width: 500,
    title: 'STOCK_MANAGEMENT_ADJUST_STOCK_CNT_CONFIG_TOOLTIP_TIT',
    nonFooter: true
  };
  // 검색어
  private searchKeywordType = 'MALL_PRODUCT_NO';
  private searchKeywordTypes = [
    {
      value: 'MALL_PRODUCT_NO',
      name: 'STOCK_MANAGEMENT_MALLPRODUCTNO'
    },
    {
      value: 'PRODUCT_NAME',
      name: 'STOCK_MANAGEMENT_PRODUCTNAME'
    },
    {
      value: 'PRODUCT_MANAGEMENT_CD',
      name: 'STOCK_MANAGEMENT_PRODUCTMANAGEMENTCD'
    },
    {
      value: 'PRODUCT_MANAGEMENT_CD_LIKE',
      name: 'STOCK_MANAGEMENT_PRODUCTMANAGEMENTCDLIKE'
    },
    {
      value: 'STOCK_NO',
      name: 'STOCK_MANAGEMENT_STOCKNO'
    },
    {
      value: 'OPTION_MANAGEMENT_CD',
      name: 'STOCK_MANAGEMENT_OPTIONMANAGEMENTCD'
    },
    {
      value: 'MALL_OPTION_NO',
      name: 'STOCK_MANAGEMENT_MALLOPTIONNO'
    }
  ];
  private searchTypeChange() {
    let periodCalender = this.$refs.period as any;
    if (this.searchKeywordType === 'PRODUCT_MANAGEMENT_CD') {
      periodCalender.editOption({periodTypes: ['td', '1w', '1m', '3m', '6m', '1y', 'all']});
    } else {
      periodCalender.editOption({periodTypes: ['td', '1w', '1m', '3m', '6m', '1y']});
      if (periodCalender.calendarInfo.period === 'all') {
        periodCalender.clickPeriod('3m');
      }
    }
  }
  private areaKeyword = '';
  private inputNullFlg = false;
  private inputNumberFlg = false;
  private areaKeywordFocus() {
    this.inputNullFlg = false;
    this.inputNumberFlg = false;
  }
  private keyword = '';
  private showGuide = false;

  private periodOption = {
    period: '1w'
  };

  // 판매상태
  private saleStatusTypes = 'ALL';
  private saleStatusOption = {
    name: 'saleStatusOption',
    hasAll: true,
    noBrackets: true,
    data: [
      {
        id: 'saleStatusOption_ALL',
        value: 'ALL',
        dispaly: 'COMMON_ALL_CHECK'
      },
      {
        id: 'saleStatusOption_ON_PRE_SALE',
        value: 'ON_PRE_SALE',
        dispaly: 'STOCK_MANAGEMENT_SALE_STATUS_ON_PRE_SALE'
      },
      {
        id: 'saleStatusOption_WAITING_SALE',
        value: 'WAITING_SALE',
        dispaly: 'STOCK_MANAGEMENT_SALE_STATUS_WAITING_SALE'
      },
      {
        id: 'saleStatusOption_ON_SALE',
        value: 'ON_SALE',
        dispaly: 'STOCK_MANAGEMENT_SALE_STATUS_ON_SALE'
      },
      {
        id: 'saleStatusOption_END_SALE',
        value: 'END_SALE',
        dispaly: 'STOCK_MANAGEMENT_SALE_STATUS_END_SALE'
      }
    ]
  };

  // 판매설정
  private saleSettingStatusTypes = 'ALL';
  private saleSettingStatusOption = {
    name: 'saleSettingStatusOption',
    hasAll: true,
    noBrackets: true,
    data: [
      {
        id: 'saleSettingStatusOption_ALL',
        value: 'ALL',
        dispaly: 'COMMON_ALL_CHECK'
      },
      {
        id: 'saleSettingStatusOption_AVAILABLE_FOR_SALE',
        value: 'AVAILABLE_FOR_SALE',
        dispaly: 'STOCK_MANAGEMENT_SALE_SETTING_STATUS_AVAILABLE_FOR_SALE'
      },
      {
        id: 'saleSettingStatusOption_STOP_SELLING',
        value: 'STOP_SELLING',
        dispaly: 'STOCK_MANAGEMENT_SALE_SETTING_STATUS_STOP_SELLING'
      },
      {
        id: 'saleSettingStatusOption_PROHIBITION_SALE',
        value: 'PROHIBITION_SALE',
        dispaly: 'STOCK_MANAGEMENT_SALE_SETTING_STATUS_PROHIBITION_SALE'
      }
    ]
  };

  // 브랜드명
  private brandNo = 0;

  // 파트너사
  private partnerName = '';
  private partnerNo = 0;
  private partners = [];
  private partnerResult = [];
  private showResultPartner = false;
  private async searchPartner() {
    if (this.mallNo === 0) {
      alert(this.$t('COMMON_ERR_MALLNO_NULL'));
      this.partnerName = '';
      (this.$refs.partnerName as any).focus();
    } else {
      this.partnerNo = 0;
      this.partnerResult = [];
      this.showResultPartner = true;
      if(!this.partners.length){
        const {data: partners} = await this.$api.getMallsContractedPartnersByMallNo({pathParams: {mallNo: this.mallNo.toString()}});
        this.partners = partners.filter(item => {
          return item.partnerStatus === 'ACTIVE' && ( item.contractStatus === 'ACTIVE' || item.contractStatus === 'SUSPEND' );
        });
      }
      if (this.partnerName !== '') {
        let tempKey = this.partnerName.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');

        let tempRes = this.partners.filter((partner) => {
          let repName = partner.partnerName.replace(new RegExp(tempKey, 'gi'), '');
          return repName !== partner.partnerName;
        });

        tempRes.forEach((partner) => {
          let showName = partner.partnerName.replace(new RegExp(tempKey, 'gi'), '<span>$&</span>');
          this.partnerResult.push({
            showName,
            partnerName: partner.partnerName,
            partnerNo: partner.partnerNo
          });
        });
      }
    }
  }
  private blurPartner() {
    if (this.partnerNo === 0) {
      this.partnerName = '';
    }
  }
  private clickPartner(partner: any) {
    this.showResultPartner = false;
    this.partnerNo = partner.partnerNo;
    this.partnerName = partner.partnerName;
  }
  private closeResult() {
    this.showResultPartner = false;
  }

  // 카테고리
  private categoryType = 'DISPLAY_CATEGORY';
  private categoryTypes = [
    {
      value: 'DISPLAY_CATEGORY',
      name: 'STOCK_MANAGEMENT_DISPLAY_CATEGORY'
    },
    {
      value: 'CATEGORY',
      name: 'STOCK_MANAGEMENT_TYPE_CATEGORY'
    }
  ];
  // Depth1
  private standardTree = [];
  private categoriesTree = [];
  private selected1Depth = 0;
  private get depth1List() {
    let depth1 = [
      {
        value: 0,
        name: '1Depth',
        info: null as any
      }
    ];
    if (this.categoryType === 'DISPLAY_CATEGORY') {
      if (this.categoriesTree && this.categoriesTree.length > 0) {
        this.categoriesTree.forEach((item) => {
          let info = {
            categoryNo: item.displayCategoryNo,
            name: item.displayCategoryName,
            child: item.children
          };
          depth1.push({
            value: info.categoryNo,
            name: info.name,
            info
          });
        });
      }
    } else {
      if (this.standardTree && this.standardTree.length > 0) {
        this.standardTree.forEach((item) => {
          depth1.push({
            value: item.categoryNo,
            name: item.name,
            info: item
          });
        });
      }
    }
    return depth1;
  }
  // Depth2
  private selected2Depth = 0;
  private get depth2List() {
    let depth2 = [
      {
        value: 0,
        name: '2Depth',
        info: null as any
      }
    ];
    if (this.selected1Depth !== 0) {
      let depth1Item = this.depth1List.find((item: any) => item.value === this.selected1Depth);
      if (depth1Item && depth1Item.info.child.length) {
        depth1Item.info.child.forEach((item: any) => {
          let info = item;
          if (this.categoryType === 'DISPLAY_CATEGORY') {
            info = {
              categoryNo: item.displayCategoryNo,
              name: item.displayCategoryName,
              child: item.children
            };
          }
          depth2.push({
            value: info.categoryNo,
            name: info.name,
            info
          });
        });
      }
    }
    return depth2;
  }
  // Depth3
  private selected3Depth = 0;
  private get depth3List() {
    let depth3 = [
      {
        value: 0,
        name: '3Depth',
        info: null as any
      }
    ];
    if (this.selected2Depth !== 0) {
      let depth2Item = this.depth2List.find((item: any) => item.value === this.selected2Depth);
      if (depth2Item && depth2Item.info.child.length) {
        depth2Item.info.child.forEach((item: any) => {
          let info = item;
          if (this.categoryType === 'DISPLAY_CATEGORY') {
            info = {
              categoryNo: item.displayCategoryNo,
              name: item.displayCategoryName,
              child: item.children
            };
          }
          depth3.push({
            value: info.categoryNo,
            name: info.name,
            info
          });
        });
      }
    }
    return depth3;
  }
  // Depth4
  private selected4Depth = 0;
  private get depth4List() {
    let depth4 = [
      {
        value: 0,
        name: '4Depth',
        info: null as any
      }
    ];
    if (this.selected3Depth !== 0) {
      let depth3Item = this.depth3List.find((item: any) => item.value === this.selected3Depth);
      if (depth3Item && depth3Item.info.child.length) {
        depth3Item.info.child.forEach((item: any) => {
          let info = item;
          if (this.categoryType === 'DISPLAY_CATEGORY') {
            info = {
              categoryNo: item.displayCategoryNo,
              name: item.displayCategoryName,
              child: item.children
            };
          }
          depth4.push({
            value: info.categoryNo,
            name: info.name,
            info
          });
        });
      }
    }
    return depth4;
  }
  // Depth5
  private selected5Depth = 0;
  private get depth5List() {
    let depth5 = [
      {
        value: 0,
        name: '5Depth',
        info: null as any
      }
    ];
    if (this.selected4Depth !== 0) {
      let depth4Item = this.depth4List.find((item: any) => item.value === this.selected4Depth);
      if (depth4Item && depth4Item.info.child.length) {
        depth4Item.info.child.forEach((item: any) => {
          let info = item;
          if (this.categoryType === 'DISPLAY_CATEGORY') {
            info = {
              categoryNo: item.displayCategoryNo,
              name: item.displayCategoryName,
              child: item.children
            };
          }
          depth5.push({
            value: info.categoryNo,
            name: info.name,
            info
          });
        });
      }
    }
    return depth5;
  }
  private changeCategory(depth: number) {
    if (depth < 1) {
      this.selected1Depth = 0;
    }
    if (depth < 2) {
      this.selected2Depth = 0;
    }
    if (depth < 3) {
      this.selected3Depth = 0;
    }
    if (depth < 4) {
      this.selected4Depth = 0;
    }
    this.selected5Depth = 0;
  }

  // 기간
  private periodType = 'REGISTER_YMDT';
  private periodTypes = [
    {
      value: 'REGISTER_YMDT',
      name: 'STOCK_MANAGEMENT_TERM_REGISTER_YMDT'
    },
    {
      value: 'START_YMDT',
      name: 'STOCK_MANAGEMENT_TERM_START_YMDT'
    },
    {
      value: 'END_YMDT',
      name: 'STOCK_MANAGEMENT_TERM_END_YMDT'
    },
    {
      value: 'UPDATE_YMDT',
      name: 'STOCK_MANAGEMENT_TERM_UPDATE_YMDT'
    }
  ];
  private startYmdt: string = addDay(new Date(), -7);
  private endYmdt: string = getToday();

  // 상세검색
  // 쇼핑몰
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private mallNo = 0;
  private get mallList() {
    let list: any = [
      {
        value: 0,
        name: this.$t('STOCK_MANAGEMENT_SHOPPING_MALL_FULL')
      }
    ];
    if (this.malls) {
      this.malls.forEach((mall) => {
        list.push({
          value: mall.mallNo,
          name: mall.mallName
        });
      });
    }
    return list;
  }
  private async changeMall() {
    // 브랜드명
    this.brandNo = 0;
    // 파트너사
    this.partnerName = '';
    this.partnerNo = 0;
    this.partners = [];
    this.partnerResult = [];
    // 카테고리
    this.categoriesTree = [];
    this.changeCategory(0);

    if (this.mallNo !== 0) {
      const categoriesResponse = await this.$api.getDisplayCategoriesTree({params: {mallNo: this.mallNo}});
      this.categoriesTree = categoriesResponse.data;
    }
  }
  // 재고여부
  private stockRangeType = -1;
  private stockRangeTypes = [
    {
      value: -1,
      name: 'STOCK_MANAGEMENT_STOCKRANGETYPE_NONE'
    },
    {
      value: 0,
      name: 'STOCK_MANAGEMENT_SOLD_OUT'
    },
    {
      value: 5,
      name: 'STOCK_MANAGEMENT_UNDER_FIVE'
    },
    {
      value: 10,
      name: 'STOCK_MANAGEMENT_UNDER_TEN'
    },
    {
      value: 50,
      name: 'STOCK_MANAGEMENT_UNDER_FIFTY'
    },
    {
      value: 100,
      name: 'STOCK_MANAGEMENT_UNDER_HUNDRED'
    }
  ];
  // 플랫폼 구분
  private platformDisplayType = 'NONE';
  private platformDisplayTypes = [
    {
      value: 'NONE',
      name: 'STOCK_MANAGEMENT_NONE'
    },
    {
      value: 'PC',
      name: 'STOCK_MANAGEMENT_PC'
    },
    {
      value: 'MOBILE_APP',
      name: 'STOCK_MANAGEMENT_MOBILE_APP'
    },
    {
      value: 'MOBILE_WEB ',
      name: 'STOCK_MANAGEMENT_MOBILE_WEB'
    }
  ];

  // 조회
  private size = 30;
  private nowPage = 1;
  private async search(page: number = 1, size?: number) {
    localStorage.removeItem('checkedRows');
    this.nowPage = page;
    if (size) {
      this.size = size;
    }
    if (this.checkAll()) {
      let request: GetOptionsStocksRequest = {
        params: this.getParams()
      };
      let {data} = await this.$api.getOptionsStocks(request);
      this.stocks = data.stockViews.map((stockView) => {
        return {
          ...stockView,
          fullDisplayCategoryName: stockView.categoryFullName ? stockView.categoryFullName.split('|')[0] : '',
          updateOptionManagementCd: false,
          changeSafetyStock: false,
          updateStock: false,
          editStock: false
        };
      });
      this.mallProductCount = data.mallProductCount;
      this.mallProductOptionCount = data.mallProductOptionCount;
      this.gridProps.options.pageOptions.page = page;
      this.gridProps.options.pageOptions.perPage = this.size;
      this.gridProps.options.pageOptions.totalCount = data.mallProductCount;
    }
  }
  private getParams() {
    let params: OptionsStocksParams = {
      mallNos: '',
      categoryType: this.categoryType,
      periodType: this.periodType,
      startYmdt: '',
      endYmdt: '',
      searchKeywordType: this.searchKeywordType,
      platformDisplayType: this.platformDisplayType,
      saleStatusTypes: this.saleStatusTypes,
      saleSettingStatusTypes: this.saleSettingStatusTypes,
      page: this.nowPage,
      size: this.size
    };

    if (this.mallNo === 0) {
      params.mallNos = this.malls.map((mall) => mall.mallNo).join(',');
    } else {
      params.mallNos = this.mallNo.toString();
    }
    if (this.brandNo !== 0) {
      params.brandNo = this.brandNo;
    }
    if (this.partnerNo !== 0) {
      params.partnerNo = this.partnerNo;
    }
    let categoryNo = this.selected5Depth || this.selected4Depth || this.selected3Depth || this.selected2Depth || this.selected1Depth || 0;
    if (categoryNo !== 0) {
      params.categoryNo = categoryNo;
    }
    if (this.startYmdt !== '') {
      params.startYmdt = this.startYmdt + ' 00:00:00';
    }
    if (this.endYmdt !== '') {
      params.endYmdt = this.endYmdt + ' 23:59:59';
    }
    if (this.searchKeywordType === 'PRODUCT_MANAGEMENT_CD_LIKE') {
      params.keyword = this.keyword.trim();
    } else {
      let tempKeyword = this.areaKeyword.replaceAll(/\r\n/g, ',').replaceAll(/\n/g, ',');
      tempKeyword = tempKeyword
        .split(',')
        .filter((item: string) => item !== null && item.trim() !== '')
        .join(',');
      params.keyword = tempKeyword;
    }
    if (this.saleStatusTypes === 'ALL') {
      params.saleStatusTypes = this.saleStatusOption.data
        .filter((item: any) => item.value !== 'ALL')
        .map((item: any) => item.value)
        .join(',');
    }
    if (this.saleSettingStatusTypes === 'ALL') {
      params.saleSettingStatusTypes = this.saleSettingStatusOption.data
        .filter((item: any) => item.value !== 'ALL')
        .map((item: any) => item.value)
        .join(',');
    }
    if (this.stockRangeType !== -1) {
      params.maxStockAmount = this.stockRangeType;
    }

    return params;
  }

  private checkAll() {
    this.inputNullFlg = false;
    this.inputNumberFlg = false;
    let res = true;
    let tempKeyword = this.areaKeyword.replaceAll(/\r\n/g, ',').replaceAll(/\n/g, ',');
    tempKeyword = tempKeyword
      .split(',')
      .filter((item: string) => item !== null && item.trim() !== '')
      .join(',');
    switch (this.searchKeywordType) {
      case 'MALL_PRODUCT_NO':
      case 'STOCK_NO':
      case 'MALL_OPTION_NO':
        if (tempKeyword !== '') {
          const noRegex = /^[0-9,]+$/;
          if (!noRegex.test(tempKeyword)) {
            this.inputNumberFlg = true;
            (this.$refs.areaKeyword as any).focus();
            res = false;
          }
        }
        break;
      case 'PRODUCT_MANAGEMENT_CD':
        if (this.startYmdt === '' && this.endYmdt === '' && tempKeyword.trim() === '') {
          this.inputNullFlg = true;
        }
        break;
    }
    // if (res && this.saleStatusTypes === '') {
    //   alert(this.$t('STOCK_MANAGEMENT_SALE_STATUS_TYPE_ERROR'));
    //   res = false;
    // }
    // if (res && this.saleSettingStatusTypes === '') {
    //   alert(this.$t('STOCK_MANAGEMENT_SALE_SETTING_STATUS_TYPE_ERROR'));
    //   res = false;
    // }
    return res;
  }

  // 초기화
  private reset() {
    this.searchKeywordType = 'MALL_PRODUCT_NO';
    this.areaKeyword = '';
    this.keyword = '';
    this.saleStatusTypes = 'ALL';
    this.saleSettingStatusTypes = 'ALL';
    this.brandNo = 0;
    this.partnerName = '';
    this.partnerNo = 0;
    this.partners = [];
    this.partnerResult = [];
    this.categoryType = 'DISPLAY_CATEGORY';
    this.categoriesTree = [];
    this.changeCategory(0);
    this.periodType = 'REGISTER_YMDT';
    (this.$refs.period as any).clickPeriod('3m');
    this.mallNo = 0;
    this.stockRangeType = -1;
    this.platformDisplayType = 'NONE';
    (this.$refs.brandSearcherRef as BrandSearcher)?.resetBrand();
  }

  // 조정재고 일괄적용
  private openPop(type: string) {
    let checkedRows = (this.$refs.itemTable as any).gridFunction('getCheckedRows');
    if (checkedRows.length === 0) {
      alert(this.$t('STOCK_MANAGEMENT_ERR_PRODUCT_NO_SELECT'));
      return;
    }
    localStorage.setItem('checkedRows', JSON.stringify(checkedRows));
    sessionStorage.setItem('stockCallBackName', 'stockCallBackName');
    (window as any).stockCallBackName = this.callBack;
    ncpPopup(`/product/stock/modifyPopup?type=${type}`, 'stockModifyPopup');
  }
  private showFailLayer = false;
  private failLayerType = 'adjust';
  private failTotalCnt = 0;
  private failList = [];
  private async callBack(info: any) {
    (window as any).stockCallBackName = undefined;
    localStorage.removeItem('checkedRows');
    sessionStorage.removeItem('stockCallBackName');

    let itemTable = this.$refs.itemTable as any;
    let checkedRows = itemTable.gridFunction('getCheckedRows');
    if (info.confirmType && checkedRows.length > 0) {
      this.failList = [];
      checkedRows.forEach((rowItem: any) => {
        let failMsg = '';
        if (info.type === 'adjust') {
          failMsg = info.stockCnt >= 0 && info.stockCnt < 100000000 ? '' : (this.$t('STOCK_MANAGEMENT_ADJUST_CNT_MSG') as string);
        } else {
          if (rowItem.stockCnt + info.stockCnt >= 100000000) {
            failMsg = this.$t('STOCK_MANAGEMENT_ADJUST_CNT_MSG') as string;
          } else {
            failMsg = rowItem.stockCnt + info.stockCnt >= 0 ? '' : (this.$t('STOCK_MANAGEMENT_EDIT_CNT_MSG') as string);
          }
        }
        if (failMsg !== '') {
          this.failList.push({
            mallProductNo: rowItem.mallProductNo,
            mallOptionNo: rowItem.mallOptionNo,
            stockNo: rowItem.stockNo,
            validMsg: failMsg
          });
        } else {
          $(`.${info.type}StockInput[data-row-key=${rowItem.rowKey}]`).val(info.stockCnt).trigger('blur');
        }
      });
      if (this.failList.length > 0) {
        this.failTotalCnt = checkedRows.length;
        this.failLayerType = info.type;
        this.showFailLayer = true;
      }

      const stockInfos = checkedRows.map((row: any) => {
        const stockInfo = {
          mallOptionNo: row.mallOptionNo,
          mallNo: row.mallNo,
          mallProductNo: row.mallProductNo,
          stockNo: row.stockNo
        };
        return stockInfo;
      });

      if (info.type === 'adjust') {
        const request: PostStocksAdjustRequest = {
          data: {
            stockInfos: stockInfos,
            stockManageCnt: info.stockCnt
          }
        };
        await this.$api.postStocksAdjust(request);
      } else {
        const request: PostStocksEditRequest = {
          data: {
            stockInfos: stockInfos,
            stockManageCnt: info.stockCnt
          }
        };
        await this.$api.postStocksEdit(request);
      }
      alert(this.$t('STOCK_MANAGEMENT_LAST_SAVED'));
      this.search(this.nowPage);
    } else {
      itemTable.gridFunction('uncheckAll');
    }
  }
  // 최종저장
  private async finalSave() {
    let itemTable = this.$refs.itemTable as any;
    let checkedRows = itemTable.gridFunction('getCheckedRows');
    if (checkedRows.length === 0) {
      alert(this.$t('STOCK_MANAGEMENT_ERR_PRODUCT_NO_SELECT'));
      return;
    }

    const stockInfos = checkedRows.map((row: any) => {
      let stockManageType = '';
      let stockManageCnt = 0;
      if (row.changeSafetyStock) {
        stockManageType = 'SAFETY_STOCK';
        stockManageCnt = row.adjustStockCnt;
      } else {
        if (row.editStock && row.updateStock) {
          stockManageType = 'EDIT';
          stockManageCnt = row.editStockCnt;
        } else {
          stockManageType = 'ADJUST';
          stockManageCnt = row.adjustStockCnt;
        }
      }
      const stockInfo = {
        optionManagementCode: row.optionManagementCd,
        extraManagementCode: row.extraManagementCd.replace(extraManagementCodeRegex, ''),
        mallOptionNo: row.mallOptionNo,
        stockManageCnt,
        stockManageType,
        safetyStockRequest: {
          safetyStockCnt: row.safetyStockCnt === '-' ? 0 : row.safetyStockCnt,
          safetyStockSyncYn: row.safetyStockSyncYn === 'N' ? false : true
        },
        mallNo: row.mallNo,
        mallProductNo: row.mallProductNo,
        stockNo: row.stockNo
      };
      return stockInfo;
    });

    const request: PostStocksRequest = {data: stockInfos};
    let {data} = await this.$api.postStocks(request);
    let failList = data.stockManageResults.filter((item) => !!item.failCode);
    if (failList.length > 0) {
      alert(this.$t('STOCK_MANAGEMENT_ADJUSTABLE_RANGE'));
      $('.editInput').val('');
    } else {
      alert(this.$t('STOCK_MANAGEMENT_LAST_SAVED'));
      this.search(this.nowPage);
    }
  }

  // 엑셀다운로드
  private async excelDownload() {
    let request: GetOptionsStocksExcelRequest = {
      params: this.getParams(),
      responseType: 'arraybuffer'
    };
    let response = await this.$api.getOptionsStocksExcel(request);
    const myBlob = new Blob([response.data], {type: 'application/octet-stream'});
    const qrUrl = window.URL.createObjectURL(myBlob);
    const a = document.createElement('a');
    const event = new MouseEvent('click');
    a.download = `product_option${changeDateFormat(new Date(), 'YYYY-MM-DD')}.xlsx`;
    a.href = qrUrl;
    a.dispatchEvent(event);
    window.URL.revokeObjectURL(qrUrl);
  }

  // 엑셀일괄등록
  private openUploadPop() {
    sessionStorage.setItem('uploadCallBack', 'uploadCallBack');
    (window as any).uploadCallBack = this.uploadCallBack;
    ncpPopup('/product/stock/excelUploadPopup', 'excelUploadPopup');
  }
  private async uploadCallBack(res: any) {
    sessionStorage.removeItem('uploadCallBack');

    (window as any).uploadCallBack = undefined;
    if (!res.okFlg) {
      const a = document.createElement('a');
      const event = new MouseEvent('click');
      a.download = `result_product_option${changeDateFormat(new Date(), 'YYYY-MM-DD')}.xlsx`;
      a.href = res.qrUrl;
      a.dispatchEvent(event);
      window.URL.revokeObjectURL(res.qrUrl);
    }
    this.search(this.nowPage);
  }

  // 상품조회결과
  private stocks = [];
  private mallProductCount = 0;
  private mallProductOptionCount = 0;
  private stockListOptions = {
    name: 'gridList',
    gridName: 'STOCK_MANAGEMENT_GRID',
    onLoadSearch: false,
    haveExcelDownBtn: false,
    pageSizes: [
      {
        value: '30',
        name: 'COMMON_PAGE_SIZE_30'
      },
      {
        value: '50',
        name: 'COMMON_PAGE_SIZE_50'
      },
      {
        value: '100',
        name: 'COMMON_PAGE_SIZE_100'
      }
    ]
  };

  private gridProps = {
    options: {
      columnOptions: {
        minWidth: 70,
        resizable: true,
        frozenCount: 4
      },
      rowHeaders: ['checkbox'],
      bodyHeight: 480,
      virtualScrolling: true,
      isInitialRequest: false,
      useClientSort: false,
      heightResizable: true,
      rowHeight: 35,
      minRowHeight: 35,
      pageOptions: {
        page: 1,
        perPage: 30,
        totalCount: 0
      },
      copyOptions: {
        useFormattedValue: true
      },
    },
    header: {
      height: 33,
      columns: [
        {
          name: 'stockCnt',
          renderer: warpHeaderTit
        },
        {
          name: 'editStockCnt',
          renderer: (): any => {
            const el = document.createElement('div')
            const btn = document.createElement('button')
            btn.className = 'help'
            btn.id = 'editStockCntHlepBtn'
            const onMousedown = (ev: any): any => {
              ev.stopPropagation()
            }
            btn.addEventListener('mousedown', onMousedown)
            return {
              getElement(): any {
                return el
              },
              render(props: any): any {
                el.textContent = props.columnInfo.header
                el.appendChild(btn)
              },
              beforeDestroy(): any {
                btn.removeEventListener('mousedown', onMousedown)
              },
            }
          },
        },
        {
          name: 'adjustStockCnt',
          renderer: (): any => {
            const el = document.createElement('div')
            const btn = document.createElement('button')
            btn.className = 'help'
            btn.id = 'adjustStockCntHlepBtn'
            const onMousedown = (ev: any): any => {
              ev.stopPropagation()
            }
            btn.addEventListener('mousedown', onMousedown)
            return {
              getElement(): any {
                return el
              },
              render(props: any): any {
                el.textContent = props.columnInfo.header
                el.appendChild(btn)
              },
              beforeDestroy(): any {
                btn.removeEventListener('mousedown', onMousedown)
              },
            }
          },
        },
      ],
    },
    columns: [
      {
        header: 'STOCK_MANAGEMENT_GRIDHEADER_MALLNAME',
        name: 'mallName',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'STOCK_MANAGEMENT_GRIDHEADER_MALLPRODUCTNO',
        name: 'mallProductNo',
        width: 100,
        align: 'center',
        formatter: (cell) => (cell.row.stockSyncYn === 'Y' ? `(M)${cell.value}` : cell.value)
      },
      {
        header: 'STOCK_MANAGEMENT_GRIDHEADER_PRODUCTMANAGEMENTCD',
        name: 'productManagementCd',
        width: 100,
        align: 'center'
      },
      {
        header: 'STOCK_MANAGEMENT_GRIDHEADER_PRODUCTNAME',
        name: 'productName',
        width: 180,
        align: 'center'
      },
      {
        header: 'STOCK_MANAGEMENT_GRIDHEADER_MALLOPTIONNO',
        name: 'mallOptionNo',
        width: 100,
        align: 'center'
      },
      {
        header: 'STOCK_MANAGEMENT_GRIDHEADER_OPTIONMANAGEMENTCD',
        name: 'optionManagementCd',
        width: 100,
        align: 'center',
        editOptions: {
          type: 'text',
          useViewMode: true
        },
        formatter: (cell: any) => {
          const isItem = cell.row.itemYn === 'Y';
          const className = `optionManagementCdInput ${isItem ? 'noEdit' : 'editInput'}`;
          return this.getHtml(className, cell.value || '', 45, cell.row, 'data-type="optionManagementCd"');
        },
        copyOptions: {
          useFormattedValue: false
        }
      },
      {
        header: 'STOCK_MANAGEMENT_EXTRAMANAGEMENTCD',
        name: 'extraManagementCd',
        width: 100,
        align: 'center',
        editOptions: {
          type: 'text',
          useViewMode: true
        },
        formatter: (cell: any) => {
          const isItem = cell.row.itemYn === 'Y';
          const className = `extraManagementCdInput ${isItem ? 'noEdit' : 'editInput'}`
          const convertedValue = cell.value.replace(extraManagementCodeRegex, '');

          return this.getHtml(className, convertedValue || '', 45, cell.row, 'data-type="extraManagementCd"');
        },
        copyOptions: {
          useFormattedValue: false
        }
      },
      {
        header: 'STOCK_MANAGEMENT_GRIDHEADER_OPTIONNAMEANDVALUE',
        name: 'optionNameAndValue',
        width: 180,
        align: 'left',
        formatter: (cell: any) => {
          return getOptionNameAndValue(cell.row.optionType, cell.row.optionName, cell.row.optionValue);
        }
      },
      {
        header: 'STOCK_MANAGEMENT_GRIDHEADER_BRANDNAME',
        name: 'brandName',
        width: 80,
        align: 'center'
      },
      {
        header: 'STOCK_MANAGEMENT_GRIDHEADER_PARTNERNAME',
        name: 'partnerName',
        width: 80,
        align: 'center'
      },
      {
        header: 'STOCK_MANAGEMENT_GRIDHEADER_SALEPERIOD',
        name: 'salePeriod',
        width: 100,
        align: 'center',
        formatter: (cell: any) => {
          return [cell.row.saleStartYmdt, cell.row.saleEndYmdt].join('~');
        }
      },
      {
        header: 'STOCK_MANAGEMENT_GRIDHEADER_CATEGORYFULLNAME',
        name: 'fullDisplayCategoryName',
        width: 130,
        align: 'center',
        formatter: (cell: any) => {
          return `<a href="javascript:;" class="openCategory" data-mall-product-no="${cell.row.mallProductNo}">${cell.value}</a>`;
        },
        copyOptions: {
          useFormattedValue: false
        }
      },
      {
        header: 'STOCK_MANAGEMENT_GRIDHEADER_SALEPRICE',
        name: 'salePrice',
        width: 100,
        align: 'center',
        formatter: (cell: any) => {
          return formatCurrency(cell.value);
        }
      },
      {
        header: 'STOCK_MANAGEMENT_GRIDHEADER_APPLYDISCOUNTSALEPRICE',
        name: 'applyDiscountSalePrice',
        width: 100,
        align: 'center',
        formatter: (cell: any) => {
          let showPrice = '-';
          if (cell.value && cell.value !== cell.row.salePrice) {
            showPrice = formatCurrency(cell.value);
          }
          return showPrice;
        }
      },
      {
        header: 'STOCK_MANAGEMENT_GRIDHEADER_APPLYOPTIONADDPRICE',
        name: 'applyOptionAddPrice',
        width: 100,
        align: 'center',
        formatter: (cell: any) => {
          let optionUsed = cell.row.optionType !== 'DEFAULT';
          return optionUsed ? formatCurrency(cell.value) : '-';
        }
      },
      {
        header: 'STOCK_MANAGEMENT_GRIDHEADER_STOCKCNT',
        name: 'stockCnt',
        width: 80,
        align: 'center',
        formatter: (cell: any) => {
          return formatCurrency(cell.value);
        }
      },
      {
        header: 'STOCK_MANAGEMENT_GRIDHEADER_ADJUSTSTOCKCNT',
        name: 'adjustStockCnt',
        width: 80,
        align: 'center',
        editOptions: {
          type: 'text',
          useViewMode: false
        },
        formatter: (cell: any) => {
          return this.getHtml('ncp_input adjustStockInput editInput', cell.value, 8, cell.row, 'data-max-length="8" data-type="adjust" data-no-message="true"');
        },
        copyOptions: {
          useFormattedValue: false
        }
      },
      {
        header: 'STOCK_MANAGEMENT_GRIDHEADER_EDITSTOCKCNT',
        name: 'editStockCnt',
        width: 80,
        align: 'center',
        editOptions: {
          type: 'text',
          useViewMode: false
        },
        formatter: (cell: any) => {
          return this.getHtml('ncp_input editStockInput editInput', cell.value, 8, cell.row, 'data-max-length="8" data-type="edit" data-no-message="true" data-negative="true"');
        },
        copyOptions: {
          useFormattedValue: false
        }
      },
      {
        header: 'STOCK_MANAGEMENT_GRIDHEADER_SAFETYSTOCKCNT',
        name: 'safetyStockCnt',
        width: 100,
        align: 'center',
        editOptions: {
          type: 'text',
          useViewMode: false
        },
        formatter: (cell: any) => {
          if (!cell.row.changeSafetyStock) {
            cell.value = cell.row.wmsUseYn === 'Y' ? cell.value : '-';
          }
          return this.getHtml('ncp_input safetyStockInput editInput', cell.value, 8, cell.row, 'data-max-length="8" data-type="safetyStockCnt"');
        },
        copyOptions: {
          useFormattedValue: false
        }
      },
      {
        header: 'STOCK_MANAGEMENT_GRIDHEADER_SAFETYSTOCKSYNCYN',
        name: 'safetyStockSyncYn',
        width: 140,
        align: 'center',
        formatter: ({row}: any): string => {
          let selectedValue = row.safetyStockSyncYn;
          const readonly = (this.$refs.itemTable as any).getCheckedRowKeys().includes(row.rowKey) ? '' : 'readonly';
          let safetyStockSyncSelectCheck = true;
          if (row.wmsUseYn === 'Y' && readonly === '') {
            safetyStockSyncSelectCheck = false;
          }

          let selectBox = `<select data-stock-no="${row.mallProductNo}" name="safetyStockSyncSelect" data-row-key="${row.rowKey}"${safetyStockSyncSelectCheck ? ' disabled' : ''}>`;
          selectBox += `<option value="Y"${selectedValue === 'Y' ? ' selected="selected"' : ''}>${window.$t('STOCK_MANAGEMENT_GRID_SAFETYSTOCKSYNCY')}</option>`;
          selectBox += `<option value="N"${selectedValue === 'N' ? ' selected="selected"' : ''}>${window.$t('STOCK_MANAGEMENT_GRID_SAFETYSTOCKSYNCN')}</option>`;
          selectBox += '</select>';
          return selectBox;
        },
        copyOptions: {
          useFormattedValue: false,
          customValue: (value) => {
            return value === 'Y' ? window.$t('STOCK_MANAGEMENT_GRID_SAFETYSTOCKSYNCY') : window.$t('STOCK_MANAGEMENT_GRID_SAFETYSTOCKSYNCN');
          }
        }
      },
      {
        header: 'STOCK_MANAGEMENT_GRIDHEADER_STOCKNO',
        name: 'stockNo',
        width: 100,
        align: 'center'
      },
      // {
      //   header: 'STOCK_MANAGEMENT_GRIDHEADER_DELIVERYWAITINGSTOCKCNT',
      //   name: 'deliveryWaitingStockCnt',
      //   width: 100,
      //   align: 'center'
      // },
      {
        header: 'STOCK_MANAGEMENT_GRIDHEADER_STOCKCHANGEHISTORYNO',
        name: 'stockChangeHistoryNo',
        width: 100,
        align: 'center',
        formatter: (cell: any) => {
          return `<a href="javascript:;" class="gridStockChangeHistory" data-stock-no=${cell.row.stockNo} data-wms-use-yn="${cell.row.wmsUseYn}">${window.$t('STOCK_MANAGEMENT_EXAMPLE')}</a>`;
        },
        copyOptions: {
          useFormattedValue: false
        }
      },
      {
        header: 'STOCK_MANAGEMENT_SALE_STATUS',
        name: 'saleStatusType',
        width: 100,
        align: 'center',
        formatter: (cell: any) => {
          return cell.value === 'PRE_APPROVAL_STATUS' || cell.row.saleSettingStatusType === 'PROHIBITION_SALE' ? '-' : window.$t(`STOCK_MANAGEMENT_SALE_STATUS_${cell.value}`);
        }
      },
      {
        header: 'STOCK_MANAGEMENT_SALE_SETTING_STATUS',
        name: 'saleSettingStatusType',
        width: 100,
        align: 'center',
        formatter: (cell: any) => {
          return window.$t(`STOCK_MANAGEMENT_SALE_SETTING_STATUS_${cell.value}`);
        }
      },
      {
        header: 'STOCK_MANAGEMENT_GRID_UPDATEADMINNAME',
        name: 'updateAdminName',
        width: 100,
        align: 'center'
      },
      {
        header: 'STOCK_MANAGEMENT_GRID_UPDATEYMDT',
        name: 'updateYmdt',
        width: 130,
        align: 'center',
        formatter: (cell: any) => {
          if (cell.value) {
            return changeDateFormat(cell.value, 'YYYY-MM-DD HH:mm');
          }
          return '';
        }
      }
    ]
  };

  private openCategory(e: any) {
    const mallProductNo = $(e.target).data('mallProductNo');
    ncpPopup(`/product/popup/displayCategoryInfo?mallProductNo=${mallProductNo}`, this.$t('STOCK_MANAGEMENT_CATEGORY_INFO_POP'), 550, 350);
  }
  private getHtml(className, value, maxLength, rowData, otherAttr) {
    let itemTable = this.$refs.itemTable as any;
    const safetyStockSyncYn = itemTable.gridFunction('getValue', [rowData.rowKey, 'safetyStockSyncYn']) === 'Y';
    const usedWms = itemTable.gridFunction('getValue', [rowData.rowKey, 'wmsUseYn']) === 'Y';

    let readonly = itemTable.getCheckedRowKeys().includes(rowData.rowKey) ? '' : 'readonly';
    if (className.indexOf('safetyStockInput') >= 0) {
      if (safetyStockSyncYn || !usedWms) {
        readonly = 'readonly';
      }
    }
    return `<input type="text" class="${className}" maxlength="${maxLength}" data-row-key="${rowData.rowKey}" ${otherAttr} value="${value || ''}" ${readonly} >`;
  }
  private toggleGridInput(rowKey, readonly) {
    let itemTable = this.$refs.itemTable as any;
    const safetyStockSyncYn = itemTable.gridFunction('getValue', [rowKey, 'safetyStockSyncYn']) === 'Y';
    const usedWms = itemTable.gridFunction('getValue', [rowKey, 'wmsUseYn']) === 'Y';
    let safetyStockSyncSelectCheck = true;
    if (usedWms && !readonly) {
      safetyStockSyncSelectCheck = false;
    }
    $(`select[data-row-key=${rowKey}]`).filter('[name=safetyStockSyncSelect]').prop('disabled', safetyStockSyncSelectCheck);

    let gridInputClass = ['.adjustStockInput', '.editStockInput', '.optionManagementCdInput:not(.noEdit)'];
    if (usedWms && !safetyStockSyncYn) {
      gridInputClass.push('.safetyStockInput');
    }
    const $target = $(`input[data-row-key=${rowKey}]`).filter(gridInputClass.join(','));
    $target.prop('readonly', readonly);
  }
  private onChangeInput(e: any) {
    let itemTable = this.$refs.itemTable as any;
    const rowKey = $(e.target).data('rowKey');
    const targetType = $(e.target).data('type');
    if (targetType === 'optionManagementCd') {
      itemTable.gridFunction('setValue', [rowKey, 'updateOptionManagementCd', true]);
      itemTable.gridFunction('setValue', [rowKey, 'optionManagementCd', $(e.target).val()]);
      $(e.target).val($(e.target).val() || '');
      return;
    } else if (targetType === 'safetyStockCnt') {
      itemTable.gridFunction('setValue', [rowKey, 'changeSafetyStock', true]);
      itemTable.gridFunction('setValue', [rowKey, 'safetyStockCnt', $(e.target).val()]);
      return;
    } else if (targetType === 'extraManagementCd') {
      itemTable.gridFunction('setValue', [rowKey, 'extraManagementCd', $(e.target).val()]);
      return;
    }
    this.checkStockCntInput(e, rowKey, targetType);
  }
  private checkStockCntInput(e: any, rowKey: any, targetType: any) {
    let itemTable = this.$refs.itemTable as any;
    const isAdjust = targetType === 'adjust';
    const reverseType = isAdjust ? 'edit' : 'adjust';
    const rowData = itemTable.gridFunction('getRow', [rowKey]);
    const targetStockCnt = $(e.target).val() === '' ? 0 : Number($(e.target).val());
    const value = isAdjust ? targetStockCnt - rowData.stockCnt : targetStockCnt + rowData.stockCnt;
    if ((!isAdjust && value < 0) || value >= 100000000) {
      alert(this.$t('STOCK_MANAGEMENT_ADJUSTABLE_RANGE'));
      $(e.target).val('').focus();
      return;
    }

    $(`.${reverseType}StockInput[data-row-key=${rowKey}]`).val($(e.target).val() !== '' ? value : '');
    const adjustStockCnt = this.getGridValue(isAdjust ? targetStockCnt : value);
    const editStockCnt = this.getGridValue(isAdjust ? value : targetStockCnt);

    itemTable.gridFunction('setValue', [rowKey, 'adjustStockCnt', $(e.target).val() !== '' ? adjustStockCnt : '']);
    itemTable.gridFunction('setValue', [rowKey, 'updateStock', $(e.target).val() !== '' && adjustStockCnt !== '']);
    itemTable.gridFunction('setValue', [rowKey, 'editStockCnt', $(e.target).val() !== '' ? editStockCnt : '']);
    itemTable.gridFunction('setValue', [rowKey, 'editStock', isAdjust ? false : $(e.target).val() !== '']);
  }
  private getGridValue(value: any) {
    return value === 0 ? '0' : value;
  }
  private formatNum(ev: any) {
    let numTemp = ev.target.value.replace(/[^0-9]+/g, '');
    let dataNegative = $(ev.target).data('negative');
    if (dataNegative) {
      numTemp = ev.target.value.replace(/[^0-9-]+/g, '');
    }
    ev.target.value = numTemp;
  }

  private historyStockNo = '';
  private historyUsedWms = false;
  private showHistoryFlg = false;

  private showHistoryPopup(rowData: Row) {
    this.historyStockNo = rowData.stockNo.toString()
    this.historyUsedWms = rowData.wmsUseYn === 'Y'
    this.showHistoryFlg = true;
  }

  private onItemClicked(gridProps: GridEventProps): void {
    if (gridProps.columnName !== 'stockChangeHistoryNo') return
    const rowData: Row = (this.$refs.itemTable as any).getRowAt(gridProps.rowKey);
    this.showHistoryPopup(rowData)
  }


  private changeSafetyStockSyncYn(e: any) {
    let itemTable = this.$refs.itemTable as any;
    const rowKey = $(e.target).data('rowKey');
    $(`.safetyStockInput[data-row-key=${rowKey}]`).prop('readonly', $(e.target).val() === 'Y');
    itemTable.gridFunction('setValue', [rowKey, 'safetyStockSyncYn', $(e.target).val()]);
  }
  private async mounted() {
    $('body').on('click','#editStockCntHlepBtn',() => this.ifExchange = true);
    $('body').on('click','#adjustStockCntHlepBtn',() => this.ifStock = true);

    await this.fetchMalls();
    if (this.malls.length === 1) { //해당 서비스에서 운영하는 쇼핑몰이 1개일 때
      this.mallNo = this.malls[0].mallNo;
      const categoriesResponse = await this.$api.getDisplayCategoriesTree({params: {mallNo: this.mallNo}});
      this.categoriesTree = categoriesResponse.data;
    }
    let standardCategoriesTree = await this.$api.getStandardCategoriesTree({params: {mallNo: this.malls[0].mallNo.toString()}});
    this.standardTree = standardCategoriesTree.data.tree;
    await this.search(1);
    let _this = this;
    this.$nextTick(() => {
      let itemTable = _this.$refs.itemTable as any;
      itemTable.gridFunction('on', [
        'check',
        (ev: any) => {
          _this.toggleGridInput(ev.rowKey, false);
        }
      ]);
      itemTable.gridFunction('on', [
        'uncheck',
        (ev: any) => {
          _this.toggleGridInput(ev.rowKey, true);
        }
      ]);
      $('body').on('click', '.openCategory', $.proxy(_this.openCategory, _this));
      $('body').on('blur', '.editInput', $.proxy(_this.onChangeInput, _this));
      $('body').on('keyup', '.ncp_input', $.proxy(_this.formatNum, _this));
      $('body').on('change', '[name=safetyStockSyncSelect]', $.proxy(_this.changeSafetyStockSyncYn, _this));
    });
  }
  private created() {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
    localStorage.removeItem('checkedRows');
  }
  private beforeDestroy() {
    $('body').off('click', '.openCategory');
    $('body').off('blur', '.editInput');
    $('body').off('keyup', '.ncp_input');
    $('body').off('change', '[name=safetyStockSyncSelect]');
  }
}
